import React, { Component } from "react";

import { Grid, Row, Col, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Card } from "components/Card/Card.jsx";
import { StatsCard } from "components/StatsCard/StatsCard.jsx";

import { adminUserActions } from '../../redux/actions/admin-user-action';

import { festivalActions } from '../../redux/actions/festival-action';
import { confirmAlert } from 'react-confirm-alert';
import festivalsIcon from "assets/img/festivals.svg";
import userlIcon from "assets/img/user_big.svg";
import 'react-confirm-alert/src/react-confirm-alert.css';


class DashboardCompanyAdminPage extends Component {
  constructor(props){
    super(props);
    this.state = {
      dashboardCount : {},
      latestFestivals : {},
      companyId :this.props.userAdmin.user.company_id
    };

    this.deleteFestival = this.deleteFestival.bind(this);
    this.deleteConfirmFestival = this.deleteConfirmFestival.bind(this);

  }


  deleteConfirmFestival(id){
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <div className="react-confirm-alert-body">
              <h3>Delete Festival</h3>
              <p className="marginFromTopPopUp" >Are you sure to delete the festival?</p>
              <div className="react-confirm-alert-button-group">
                <button onClick={onClose}>No</button>
                <button onClick={() => {
                    this.deleteFestival(id)
                    onClose()
                }}>Yes</button>
              </div>
            </div>
            
          </div>
        )
      }
    })
  }
  deleteFestival(id){
    this.props.deleteFestivalCall(id);
  }
  componentDidMount() {
    this.props.getDashboardCall();
    this.props.getLatestFestivalCall(1,this.state.companyId);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.dashboardCount){
      this.setState({dashboardCount:nextProps.dashboardCount});
    }

    if (nextProps.festivalData){
      this.setState({latestFestivals:nextProps.festivalData});
    }
  }
  render() {
    const { dashboardCount, latestFestivals } = this.state;
    return (
      <div className="content">
        <Grid fluid>
          {
            dashboardCount &&
            <Row>
              <Col lg={6} sm={12}>
                <StatsCard
                  bigIcon={<img height="70" src={festivalsIcon} alt="festivalIcon"/>}
                  statsText="Total number of Festivals"
                  statsValue={dashboardCount.total_festivals}
                  statsIcon={<Link to={'/Admin/Festivals'}>{<img height="15" src={festivalsIcon} alt="festivalIcon" />}</Link>}
                  statsIconText="Festivals"
                />
              </Col>
              <Col lg={6} sm={12}>
                <StatsCard
                  bigIcon={<img height="70" src={userlIcon} alt="userIcon" />}
                  statsText="Total number of User"
                  statsValue={dashboardCount.total_users}
                  statsIcon={<img height="15" src={userlIcon} alt="userIcon" />}
                  statsIconText="Users"
                />
              </Col>
            </Row>
          }
        </Grid>

        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Recent Festivals"
                ctTableResponsive
                content={
                  <div>
                  { latestFestivals && latestFestivals.length > 0 &&
                    <Table striped hover className="myTable">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Venue</th>
                          <th className="action-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          latestFestivals.map((prop, key) => {
                          return (
                            <tr key={key}>
                              <td>{prop.name}</td>
                              <td>{prop.venue}</td>
                              <td className="action-center">
                                <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Festival Music Directors</Tooltip>}>
                                  <Link to={'/Admin/Festival/'+prop.id+'/Music-directors'} className="action-button-size"><i className="fa fa-users " /></Link>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Edit Festival</Tooltip>}>
                                  <Link to={'/Admin/Edit-Festival/'+prop.id} className="action-button-size"><i className="fa fa-pencil" /></Link>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Delete Festival</Tooltip>}>
                                  <button onClick={()=>this.deleteConfirmFestival(prop.id)} className="action-button-size"><i className="fa fa-trash " /></button>
                                </OverlayTrigger>
                              </td>
                              
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  }

                   { latestFestivals && latestFestivals.length === 0 &&
                      <h4>No Company Found</h4>
                   }
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}



const mapDispatchToProps = dispatch => {
  return ({
    deleteFestivalCall  : (id) => { dispatch(festivalActions.deleteFestival(id)) },
    getDashboardCall  : () => { dispatch(adminUserActions.dashboard()) },
    getLatestFestivalCall  : (page, companyId) => { dispatch(festivalActions.getFestivalsPagination(page, '', '', companyId, 10)) }
  });
};


function mapStateToProps(state) {
    const { dashboardCount, loading } = state.adminReducer;
    const { festivalData } = state.festivalReducer;
    const { adminType, userAdmin } = state.adminReducer;
    return {
        dashboardCount,loading, festivalData, adminType, userAdmin
    };
}

const DashboardCompanyAdmin = connect(mapStateToProps, mapDispatchToProps)(DashboardCompanyAdminPage);


export default DashboardCompanyAdmin;



// WEBPACK FOOTER //
// ./src/components/Admin/DashboardCompanyAdmin.jsx